import { Injectable } from '@angular/core';
import { QueryCondition } from '@farris/component-querycondition';
import { IQueryConditionHandler } from './handlers/iquerycondition.handler';
import { QueryConditionHandlerFactory } from './querycondition.handler.factory';
import { FrameContext } from '@farris/devkit';
import { IQuerySolutionHandler } from '@gsp-cmp/querysolution';
import { FrameworkSessionService } from '@farris/bef';

@Injectable()
export class QuerySolutionService implements IQuerySolutionHandler {
  constructor(
    private frameContext: FrameContext,
    private frameworkSessionService: FrameworkSessionService
  ) {

  }

  getUserSessionId(): string {
    return this.frameworkSessionService.getUserSessionId();
  }

  public setFilterConditions(params: Array<QueryCondition>): void {
    let queryConditionHandler: IQueryConditionHandler;
    const filterConditionList = [];
    params.forEach((qc) => {
      if (!qc.value.isEmpty()) {
        queryConditionHandler = QueryConditionHandlerFactory.getInstance().getHandler(qc.control.getControlType());
        queryConditionHandler && filterConditionList.push(...queryConditionHandler.convert(qc));
      }
    });
    // è®¾ç½®å°NgCommand params.filterå±æ§ä¸ï¼{UISTATE~/root-component/filterConditionList}
    this.frameContext.uiState['filterConditionList'] = JSON.stringify(filterConditionList);
    // const originalConditions = this.getOriginalQueryConditions(filterConditionList);
    this.frameContext.uiState['originalFilterConditionList'] = JSON.stringify(filterConditionList);
  }

  public setCurrentQueryConditions(conditions: QueryCondition[]): void {
    this.frameContext.uiState['currentQueryConditions'] = conditions;
  }
  /**
   * è¿åè¿æ»¤æ¡ä»¶ä¸­çencode
   * @param conditions - æ¥è¯¢æ¹æ¡æé å®çè¿æ»¤æ¡ä»¶
   */
  // private getOriginalQueryConditions(conditions: Array<any>): Array<any> {
  //   conditions = JSON.parse(JSON.stringify(conditions));
  //   if (conditions && Array.isArray(conditions) && conditions.length > 0) {
  //     conditions = conditions.map((item) => {
  //       if (item.hasOwnProperty('Value')) {
  //         item.Value = decodeURIComponent(item.Value);
  //       } else if (item.hasOwnProperty('value')) {
  //         const value = item.value;
  //         delete item.value;
  //         item.Value = decodeURIComponent(value);
  //       }
  //       return item;
  //     });
  //   }
  //   return conditions;
  // }
}
